import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { Users } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { SEO } from '../components/SEO';

const TeamPage = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  
  const teamMembers = [
    {
      name: 'Jack Oundjian',
      role: t('team.president'),
      image: 'https://static.wixstatic.com/media/fdc02d_a246b4a6faf34d77b821e50316706bfe~mv2.png/v1/fill/w_400,h_400,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/fdc02d_a246b4a6faf34d77b821e50316706bfe~mv2.png',
    },
    {
      name: 'Naseeb Toraubally',
      role: t('team.vpOperations'),
      image: 'https://static.wixstatic.com/media/fdc02d_d2a5df089782472fb0967569d5c1c74f~mv2.png/v1/fill/w_400,h_400,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/fdc02d_d2a5df089782472fb0967569d5c1c74f~mv2.png',
    },
    {
      name: 'Alexandre Paquin',
      role: t('team.vpSales'),
      image: 'https://static.wixstatic.com/media/fdc02d_14a1fe9281d646a6a70768606038e4ef~mv2.png/v1/fill/w_400,h_400,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/fdc02d_14a1fe9281d646a6a70768606038e4ef~mv2.png',
    },
    {
      name: 'René Arbour',
      role: t('team.salesDirector'),
      image: 'https://static.wixstatic.com/media/fdc02d_1ba1ed9a285140a5adc8b587f67e4126~mv2.png/v1/fill/w_400,h_400,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/fdc02d_1ba1ed9a285140a5adc8b587f67e4126~mv2.png',
    },
    {
      name: 'Karyn Guillemette',
      role: t('team.salesSpecialist'),
      image: null,
    },
    {
      name: 'Jean-François Gosselin',
      role: t('team.salesSpecialist'),
      image: null,
    },
    {
      name: 'François Lachance',
      role: t('team.salesSpecialist'),
      image: null,
    },
    {
      name: 'Janie Leblanc',
      role: t('team.salesSpecialist'),
      image: null,
    },
    {
      name: 'Dawson Triantopoulos-Massicotte',
      role: t('team.salesSpecialist'),
      image: null,
    },
    {
      name: 'Jun Xiang',
      role: t('team.operationsCoordinator'),
      image: null,
    },
    {
      name: 'Mélanie Taillefer',
      role: t('team.adminAssistant'),
      image: null,
    },
  ];

  const getInitials = (name) => {
    return name
      .split(' ')
      .map((n) => n[0])
      .join('')
      .toUpperCase();
  };

  return (
    <div className="min-h-screen flex flex-col bg-white" data-testid="team-page" dir={isRTL ? 'rtl' : 'ltr'}>
      <SEO 
        title="Notre Équipe"
        description="Rencontrez l'équipe d'Entrepôt Auto Montréal. Nos conseillers expérimentés sont là pour vous aider à trouver le véhicule parfait et les meilleures options de financement."
        url="https://entrepotautomontreal.ca/team"
        keywords="équipe entrepot auto, conseiller automobile montréal, expert financement auto, vendeur voiture verdun"
      />
      {/* Hero Section with Navbar */}
      <div className="relative bg-slate-900 overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0">
          <img 
            src="https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg?w=1920" 
            alt="" 
            className="w-full h-full object-cover opacity-40"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-slate-900 via-slate-900/80 to-slate-900/50" />
        </div>
        
        {/* Navbar - white background */}
        <div className="relative z-10">
          <Navbar />
        </div>
        
        {/* Hero Content */}
        <div className="relative max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-16 text-center">
          <div className="inline-flex items-center justify-center w-14 h-14 bg-[#3b82f6] rounded-xl mb-4">
            <Users className="h-7 w-7 text-white" />
          </div>
          <h1 className="text-3xl md:text-4xl font-bold mb-3 text-white" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            {t('team.title').split(' ')[0]} <span className="text-[#3b82f6]">{t('team.title').split(' ').slice(1).join(' ')}</span>
          </h1>
          <p className="text-slate-300 max-w-2xl mx-auto text-base">
            {t('team.subtitle')}
          </p>
        </div>
      </div>

      {/* Team Grid */}
      <section className="py-16">
        <div className="max-w-5xl mx-auto px-4 md:px-8">
          
          {/* Level 1: President - Jack */}
          <div className="mb-8">
            <div className="flex justify-center">
              <div
                className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow p-5 text-center w-full max-w-xs border border-slate-100"
                data-testid={`team-member-jack-oundjian`}
              >
                <div className="mb-3">
                  <div className="w-28 h-28 rounded-full mx-auto bg-gradient-to-br from-slate-100 to-slate-200 border-4 border-[#3b82f6]/20 overflow-hidden flex items-center justify-center">
                    <img
                      src={teamMembers[0].image}
                      alt={teamMembers[0].name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-0.5" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                  {teamMembers[0].name}
                </h3>
                <p className="text-[#3b82f6] font-medium text-sm">{teamMembers[0].role}</p>
              </div>
            </div>
            {/* Connector line */}
            <div className="flex justify-center mt-4">
              <div className="w-0.5 h-6 bg-gradient-to-b from-[#3b82f6] to-slate-200"></div>
            </div>
          </div>

          {/* Level 2: VPs - Naseeb and Alexandre */}
          <div className="mb-8">
            <div className="grid grid-cols-2 gap-6 max-w-xl mx-auto">
              {[teamMembers[1], teamMembers[2]].map((member) => (
                <div
                  key={member.name}
                  className="bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow p-4 text-center border border-slate-100"
                  data-testid={`team-member-${member.name.toLowerCase().replace(/\s+/g, '-')}`}
                >
                  <div className="mb-3">
                    <div className="w-24 h-24 rounded-full mx-auto bg-gradient-to-br from-slate-100 to-slate-200 border-4 border-[#3b82f6]/20 overflow-hidden flex items-center justify-center">
                      <img
                        src={member.image}
                        alt={member.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  </div>
                  <h3 className="text-base font-bold text-slate-900 mb-0.5" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                    {member.name}
                  </h3>
                  <p className="text-[#3b82f6] font-medium text-sm">{member.role}</p>
                </div>
              ))}
            </div>
            {/* Connector line */}
            <div className="flex justify-center mt-4">
              <div className="w-0.5 h-6 bg-gradient-to-b from-slate-300 to-slate-200"></div>
            </div>
          </div>

          {/* Level 3: Sales Team */}
          <div>
            <h2 className="text-lg font-bold text-slate-900 mb-6 text-center" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              {t('team.salesTeam')}
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {teamMembers.slice(3).map((member) => (
                <div
                  key={member.name}
                  className="bg-slate-50 rounded-lg p-4 text-center hover:bg-white hover:shadow-md transition-all border border-slate-100"
                  data-testid={`team-member-${member.name.toLowerCase().replace(/\s+/g, '-')}`}
                >
                  <div className="mb-2">
                    {member.image ? (
                      <div className="w-20 h-20 rounded-full mx-auto bg-gradient-to-br from-slate-100 to-slate-200 border-3 border-[#3b82f6]/20 overflow-hidden flex items-center justify-center">
                        <img
                          src={member.image}
                          alt={member.name}
                          className="w-full h-full object-cover"
                        />
                      </div>
                    ) : (
                      <div className="w-20 h-20 rounded-full mx-auto bg-gradient-to-br from-[#3b82f6] to-blue-600 flex items-center justify-center border-3 border-[#3b82f6]/20">
                        <span className="text-xl font-bold text-white">{getInitials(member.name)}</span>
                      </div>
                    )}
                  </div>
                  <h3 className="text-sm font-bold text-slate-900 mb-0.5" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                    {member.name}
                  </h3>
                  <p className="text-xs text-[#3b82f6] font-medium">{member.role}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-[#3b82f6]">
        <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            {t('team.readyToMeet')}
          </h2>
          <p className="text-blue-100 mb-8 text-lg">
            {t('team.readySubtitle')}
          </p>
          <a
            href="/contact"
            className="inline-block bg-white text-[#3b82f6] font-bold px-8 py-4 rounded-lg hover:bg-blue-50 transition-colors"
          >
            {t('team.contactUs')}
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TeamPage;
